<template>
  <div v-if="show">
    <span
      ><router-link
        :to="{
          path: link,
          query: query
        }"
        style="text-decoration: underline"
        >{{ text }}</router-link
      ></span
    >
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      show: null,
      text: null,
      link: null,
      query: null
    }
  },
  beforeMount() {
    if (this.params) {
      this.show = this.params?.show
      this.text = this.params?.text
      this.link = this.params?.link
      this.query = this.params?.query
    }
  }
}
</script>
